import { createContext } from 'react';
import { type ToggleVariantProps } from '@discover-ui/toggle/variants';

const ToggleGroupContext = createContext<ToggleVariantProps>({
  scale: undefined,
  kind: undefined,
  width: undefined,
  round: false,
});

export default ToggleGroupContext;
